import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Compass, ArrowRight, Video, Home, ScrollText } from 'lucide-react';

const POINTS = [
  [Compass, 'Live compass reading', 'Direction of your main door from your phone'],
  [ScrollText, 'Jyotish + Vastu', 'Birth chart, Mandala, 32-pada door & mantras'],
  [Video, 'Online consultation', 'Video call with a certified expert'],
  [Home, 'Physical site visit', 'Our consultant visits your property'],
];

const TICKS = Array.from({ length: 16 }).map((_, i) => `<line x1="100" y1="5" x2="100" y2="${i % 4 ? 20 : 32}" stroke="#047857" stroke-width="${i % 4 ? 1 : 3}" transform="rotate(${i * 22.5} 100 100)"></line>`).join('');

export const VastuSection = () => {
  const navigate = useNavigate();
  const [rev, setRev] = useState(null);
  useEffect(() => { axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/vastu/ratings`).then((r) => setRev(r.data)).catch(() => {}); }, []);
  return (
    <div className="mt-16 rounded-2xl border border-slate-200 bg-gradient-to-br from-emerald-50 to-amber-50/40 p-8 lg:p-12" data-testid="vastu-section">
      <div className="grid lg:grid-cols-[1.2fr_1fr] gap-10 items-center">
        <div>
          <span className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">New · Vastu Consultation</span>
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Check your property's <span className="text-emerald-700">Vastu</span></h3>
          <p className="text-lg text-slate-600 mb-6">Get a free Vastu report with mantras and remedies, then talk to our government-certified Vastu consultant or astrologer.</p>
          <button type="button" onClick={() => navigate('/vastu')} className="btn-am-primary px-8 py-3 text-sm" data-testid="vastu-section-start">
            <span>Get my free Vastu report</span> <ArrowRight size={14} />
          </button>
          {rev?.count > 0 && (
            <div className="mt-5 flex items-center gap-2 text-sm text-slate-700" data-testid="vastu-rating-summary">
              <span className="text-amber-500 text-lg">{'★'.repeat(Math.round(rev.avg))}</span>
              <b>{rev.avg}/5</b> from {rev.count} consultation{rev.count > 1 ? 's' : ''}
            </div>
          )}
        </div>
        <div className="relative grid grid-cols-2 gap-4">
          <svg viewBox="0 0 200 200" className="pointer-events-none absolute -right-10 -top-16 w-56 h-56 opacity-20 animate-[spin_30s_linear_infinite]" aria-hidden="true">
            <circle cx="100" cy="100" r="95" fill="none" stroke="#047857" strokeWidth="2" />
            <circle cx="100" cy="100" r="70" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="4 6" />
            <g dangerouslySetInnerHTML={{ __html: TICKS }} />
            <path d="M100 30 L108 100 L100 170 L92 100 Z" fill="#dc2626" opacity="0.7" />
          </svg>
          {POINTS.map(([Icon, t, d]) => (
            <div key={t} className="relative bg-white border border-slate-200 rounded-2xl p-5 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-amber-50 grid place-items-center mb-3"><Icon size={22} className="text-emerald-700" /></div>
              <p className="font-bold text-slate-900">{t}</p>
              <p className="text-sm text-slate-600 mt-1">{d}</p>
            </div>
          ))}
        </div>
      </div>
      {rev?.recent?.length > 0 && (
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="vastu-reviews">
          {rev.recent.slice(0, 3).map((r) => (
            <div key={r.at} className="rounded-2xl bg-white border border-slate-200 p-4">
              <p className="text-amber-500">{'★'.repeat(r.stars)}<span className="text-slate-300">{'★'.repeat(5 - r.stars)}</span></p>
              <p className="text-sm text-slate-700 mt-1">“{r.comment}”</p>
              <p className="text-xs text-slate-500 mt-2">— {r.name}{r.consultant ? ` · with ${r.consultant}` : ''}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
